import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  width: 100vw;
  min-height: 85vh;
  position: relative;
  .gameContainer {
    margin: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #ccc;
    border-radius: 5px;
    width: 90%;
    .header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .league-logo {
        width: 40px;
        height: auto;
      }
      .game-information {
        text-align: center;
        margin-left: 0;
        .date {
          font-weight: 700;
        }
      }

      .game-information,
      .link-container {
        flex: 1;
        text-align: flex-start;
      }
      .game-result {
        width: 40px;
        height: 40px;
        background: #001838;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        &.green {
          background: #6cd5a6;
          p {
            color: #001838;
          }
        }
        p {
          font-weight: 700;
          color: #fff;
        }
      }
    }
    .content {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 2rem 0;
      .teams {
        font-weight: 700;
        flex: 1;
        text-align: flex-start;
      }
      .points-container {
        width: 40px;
        height: 60px;
        background-color: #001838;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 14px;
        margin: 0 0.5rem;
        .points {
          color: #fff;
          font-size: 20px;
          font-weight: 700;
        }
      }
      .link-container {
        a {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-end;
          text-decoration: none;
          color: black;
          font-weight: 700;
          p {
            font-size: 12px;
          }
          .right-arrow {
            width: 25px;
            margin-left: 1rem;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 867px) {
    .gameContainer {
      width: 80%;
      flex-direction: row;
      .header {
        width: 40%;
        .league-logo {
          width: 50px;
        }
        .game-information {
          text-align: left;
          margin-left: 2rem;
        }
        .game-result {
          margin: 0 3rem;
        }
      }

      .content {
        width: 60%;
        .link-container a {
          flex-direction: row;
          align-items: center;
          p {
            font-size: 16px;
          }
        }
        .points-container {
          width: 50px;
          height: 70px;
          .points {
            font-size: 25px;
          }
        }
      }
    }
  }
`;
